<template>
	<section>
		<div class="system-path">
			<div
				:class="getPrefightClassName"
				@click="changePhaseMode('isPrefightModeOpen')"
			>
				{{ $t('home.absatz4.title') }}
			</div>
			<div
				:class="getFightClassName"
				@click="changePhaseMode('isFightModeOpen')"
			>
				{{ $t('home.absatz5.title') }}
			</div>
			<div
				:class="getPostfightClassName"
				@click="changePhaseMode('isPostfightModeOpen')"
			>
				{{ $t('home.absatz6.title') }}
			</div>
		</div>
		<div v-if="phaseModes.isPrefightModeOpen">
			<div class="phase-description">
				<div>{{ $t('home.absatz4.description.absatz1') }}</div>
			</div>
			<div :class="getPrefightContentClassName">
				<div class="phase-content-column">
					<div class="d-strategy">
						<div><img :src="denyImg" /></div>
						{{ $t('home.absatz4.strategy1.absatz1') }}
						<router-link :to="{ name: 'Grad1Prefight' }">{{
							$t('home.absatz4.strategy1.absatz1a')
						}}</router-link>
						{{ $t('home.absatz4.strategy1.absatz1b') }}
					</div>
					<div class="d-strategy">
						<div><img :src="deterImg" /></div>
						{{ $t('home.absatz4.strategy2.absatz1') }}
						<router-link :to="{ name: 'Grad1Prefight' }">{{
							$t('home.absatz4.strategy2.absatz1a')
						}}</router-link>
						{{ $t('home.absatz4.strategy2.absatz1b') }}
					</div>
					<div class="d-strategy">
						<div><img :src="detectImg" /></div>
						{{ $t('home.absatz4.strategy3.absatz1') }}
						<router-link :to="{ name: 'Grad1Prefight' }">{{
							$t('home.absatz4.strategy3.absatz1a')
						}}</router-link>
						{{ $t('home.absatz4.strategy3.absatz1b') }}
					</div>
					<div class="d-strategy">
						<div><img :src="defuseImg" /></div>
						{{ $t('home.absatz4.strategy4.absatz1') }}
						<router-link :to="{ name: 'Grad2Prefight' }">{{
							$t('home.absatz4.strategy4.absatz1a')
						}}</router-link>
						{{ $t('home.absatz4.strategy4.absatz1b') }}
						<router-link :to="{ name: 'Grad3Prefight' }">{{
							$t('home.absatz4.strategy4.absatz1c')
						}}</router-link>
						{{ $t('home.absatz4.strategy4.absatz1d') }}
					</div>
				</div>
				<div class="phase-content-column-img" :style="backgroundImageStyle" />
			</div>
		</div>
		<div v-if="phaseModes.isFightModeOpen">
			<div class="phase-description">
				<div>{{ $t('home.absatz5.description.absatz1') }}</div>
			</div>
			<div :class="getFightContentClassName">
				<div class="phase-content-column">
					<div class="d-strategy">
						<div><img :src="defendImg" /></div>
						{{ $t('home.absatz5.strategy1.absatz1a') }}
						<router-link :to="{ name: 'Grad1Infight' }">{{
							$t('home.absatz5.strategy1.absatz1b')
						}}</router-link>
					</div>
					<div>
						{{ $t('home.absatz5.note.absatz1') }}
						<router-link :to="{ name: 'Grad3Weapons' }">{{
							$t('home.absatz5.note.absatz1a')
						}}</router-link>
						{{ $t('home.absatz5.note.absatz1b') }}
						<router-link :to="{ name: 'Grad4Postfight1' }">{{
							$t('home.absatz5.note.absatz1c')
						}}</router-link>
					</div>
				</div>
				<div class="phase-content-column-img" :style="backgroundImageStyle" />
			</div>
		</div>
		<div v-if="phaseModes.isPostfightModeOpen">
			<div class="phase-description">
				<div>{{ $t('home.absatz6.description.absatz1') }}</div>
			</div>
			<div :class="getPostfightContentClassName">
				<div class="phase-content-column">
					<div class="d-strategy">
						<div><img :src="dealImg" /></div>
						{{ $t('home.absatz6.strategy1.absatz1') }}
						<router-link :to="{ name: 'Grad1Postfight1' }">{{
							$t('home.absatz6.strategy1.absatz1a')
						}}</router-link>
						{{ $t('home.absatz6.strategy1.absatz1b') }}
						<router-link :to="{ name: 'Grad2Postfight1' }">{{
							$t('home.absatz6.strategy1.absatz1c')
						}}</router-link>
						{{ $t('home.absatz6.strategy1.absatz1d') }}
						<router-link :to="{ name: 'Grad3Postfight1' }">{{
							$t('home.absatz6.strategy1.absatz1e')
						}}</router-link>
					</div>
				</div>
				<div class="phase-content-column-img" :style="backgroundImageStyle" />
			</div>
		</div>
	</section>
</template>

<script>
import prefight1 from '@/assets/grad1/prefight1.jpg'
import grappling4 from '@/assets/grad4/grappling4.jpg'
import postfight1a from '@/assets/grad1/postfight1a_small.jpg'
import deny from '@/assets/home/deny.png'
import deter from '@/assets/home/deter.png'
import detect from '@/assets/home/detect.png'
import defuse from '@/assets/home/defuse.png'
import defend from '@/assets/home/defend.png'
import deal from '@/assets/home/deal.png'

export default {
	name: 'FightPhases',
	data() {
		return {
			prefight1Img: prefight1,
			grappling4Img: grappling4,
			postfight1aImg: postfight1a,
			denyImg: deny,
			deterImg: deter,
			detectImg: detect,
			defuseImg: defuse,
			defendImg: defend,
			dealImg: deal,

			phaseModes: {
				isPrefightModeOpen: true,
				isFightModeOpen: false,
				isPostfightModeOpen: false
			},
			isMobile: window.innerWidth <= 1024
		}
	},
	computed: {
		getPrefightClassName() {
			return this.phaseModes.isPrefightModeOpen
				? 'phase-title mode-open'
				: 'phase-title'
		},
		getFightClassName() {
			return this.phaseModes.isFightModeOpen
				? 'phase-title mode-open'
				: 'phase-title'
		},
		getPostfightClassName() {
			return this.phaseModes.isPostfightModeOpen
				? 'phase-title mode-open'
				: 'phase-title'
		},
		getPrefightContentClassName() {
			return this.phaseModes.isPrefightModeOpen
				? 'phase-content mode-open'
				: 'phase-content'
		},
		getFightContentClassName() {
			return this.phaseModes.isFightModeOpen
				? 'phase-content mode-open'
				: 'phase-content'
		},
		getPostfightContentClassName() {
			return this.phaseModes.isPostfightModeOpen
				? 'phase-content mode-open'
				: 'phase-content'
		},
		backgroundImageStyle() {
			let image = ''
			let bgImage = ''
			let bgPosition = 'right center'
			let bgSize = 'contain'
			if (this.phaseModes.isPrefightModeOpen) {
				bgImage = this.prefight1Img
			} else if (this.phaseModes.isFightModeOpen) {
				bgImage = this.grappling4Img
			} else if (this.phaseModes.isPostfightModeOpen) {
				bgImage = this.postfight1aImg
			}
			if (this.isMobile) {
				image = `url('${bgImage}')`
				bgPosition = 'left center'
				// bgSize = 'unset'
			} else {
				image = `linear-gradient(90deg, black 18%, transparent 45%), url('${bgImage}')`
			}
			return {
				backgroundRepeat: 'no-repeat',
				backgroundPosition: bgPosition,
				backgroundSize: bgSize,
				backgroundImage: image
			}
		}
	},
	methods: {
		changePhaseMode(mode) {
			Object.keys(this.phaseModes).forEach((phaseModeKey) => {
				if (mode === phaseModeKey) {
					this.phaseModes[phaseModeKey] = true
				} else {
					this.phaseModes[phaseModeKey] = false
				}
			})
		}
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_startseite.json'),
			en: require('@/i18n/en/eng_startseite.json')
		}
	}
}
</script>

<style scoped lang="stylus">
.system-path {
	border-top: solid red 1px;
	display: flex;
	justify-content: center;
}
.phase-title {
	font-family: 'Red Hat Display', sans-serif;
	font-size: 1.5rem;
	font-weight: bold;
	margin-bottom: 6vh;
	margin-top: 3vh;
	position: relative;
	transition: font-size 0.3s;
	cursor: pointer;
	width: clamp(40px, 100vw, 350px);
	text-align: center;
    display: flex;
    justify-content: center;
    padding: 0 50px 0 40px;
}
.phase-title:hover {
	text-decoration: underline;
}
.phase-title.mode-open:hover {
	text-decoration: none;
}
.phase-title.mode-open {
	font-size: 2.5rem;
}
.phase-title::before {
	content: "\2662";
	position: absolute;
	top: -53px;
	bottom: 0;
	left: 50%;
	color: red;
	font-size: 1.7rem;
}
.phase-content {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	opacity: 0;
	transition: opacity 1s;
	padding: 0 10px 0 25px;
}
.phase-content.mode-open {
	opacity: 1;
}

.phase-content-column {
	flex-basis: 550px;
	display: flex;
	flex-direction: column;
	margin-right: 22px;
	margin-bottom: 35px;
}
.phase-content-column-img {
	flex-basis: 550px;
	width: 50vw;
	height: 88vh;
}

.phase-description {
	margin-bottom: 7vh;
    display: flex;
    justify-content: center;
    padding: 0 50px 0 40px;
}
.phase-description div {
    flex-basis: 1100px;
}

.d-strategy {
	font-size: 1.1rem;
	margin-bottom: 5vh;
}
.d-strategy div {
	margin-bottom: 10px;
}
.d-strategy div img {
	width: 50%;
}

@media only screen and (max-width: 1500px) {
	.phase-content-column {
		margin-right: 0;
	}
	.phase-content-column-img {
		height: 75vh;
	}
	.phase-title::before {
		top: -52px;
	}
}
@media only screen and (max-width: 1280px) {
	.phase-content-column {
		margin-right: 0;
	}
	.phase-content-column-img {
		height: 80vh;
	}
	.phase-title::before {
		top: -52px;
	}
	.phase-title.mode-open {
    	font-size: 2rem;
	}
}
@media only screen and (max-width: 1024px) {
	.phase-content-column {
		margin-right: 0;
	}
	.phase-content-column-img {
		height: 80vh;
	}
	.phase-title::before {
		top: -38px;
	}
	.phase-title.mode-open {
    	font-size: 2rem;
	}
}
@media only screen and (max-width: 912px) {
	.phase-content-column {
		margin-right: 0;
	}
	.phase-content-column-img {
		height: 50vh;
	}
	.phase-title::before {
		top: -60px;
	}
	.phase-title.mode-open {
    	font-size: 2.1rem;
	}
}
@media only screen and (max-width: 820px) {
	.phase-content-column {
		margin-right: 0;
	}
	.phase-content-column-img {
		height: 50vh;
	}
	.phase-title::before {
		top: -55px;
	}
	.phase-title.mode-open {
    	font-size: 2.3rem;
	}
}
@media only screen and (max-width: 768px) {
	.phase-content-column {
		margin-right: 0;
	}
	.phase-content-column-img {
		height: 50vh;
	}
	.phase-title::before {
		top: -50px;
	}
	.phase-title.mode-open {
    	font-size: 2.1rem;
	}
}
@media only screen and (max-width: 540px) {
	.d-strategy div img {
		width: 100%;
	}
	.phase-content-column {
		flex-basis: 300px;
	}
	.phase-content-column-img {
		flex-basis: 300px;
	}
    .phase-title {
        padding: 0;
    }
	.phase-title::before {
		top: -40px;
	}
	.phase-title.mode-open {
    	font-size: 2rem;
	}
}
@media only screen and (max-width: 500px) {
	.d-strategy div img {
		width: 100%;
	}
	.phase-content-column {
		flex-basis: 300px;
	}
	.phase-content-column-img {
		flex-basis: 300px;
	}
    .phase-title {
        padding: 0;
    }
	.phase-title::before {
		top: -48px;
	}
	.phase-title.mode-open {
    	font-size: 2rem;
	}
}
@media only screen and (max-width: 393px) {
	.d-strategy div img {
		width: 100%;
	}
	.phase-content-column {
		flex-basis: 300px;
	}
	.phase-content-column-img {
		flex-basis: 400px;
	}
    .phase-title {
        padding: 0;
    }
	.phase-title::before {
		top: -44px;
	}
	.phase-title.mode-open {
    	font-size: 1.8rem;
	}
}
@media only screen and (max-width: 375px) {
	.d-strategy div img {
		width: 100%;
	}
	.phase-content-column {
		flex-basis: 300px;
	}
	.phase-content-column-img {
		flex-basis: 400px;
	}
    .phase-title {
        padding: 0;
    }
	.phase-title::before {
		top: -40px;
	}
	.phase-title.mode-open {
    	font-size: 1.9rem;
	}
}
@media only screen and (max-width: 360px) {
	.d-strategy div img {
		width: 100%;
	}
	.phase-content-column {
		flex-basis: 300px;
	}
	.phase-content-column-img {
		flex-basis: 400px;
	}
    .phase-title {
        padding: 0;
    }
	.phase-title::before {
		top: -42px;
	}
	.phase-title.mode-open {
    	font-size: 1.9rem;
	}
}
@media only screen and (max-width: 280px) {
	.d-strategy div img {
		width: 100%;
	}
	.phase-content-column {
		flex-basis: 240px;
	}
	.phase-content-column-img {
		flex-basis: 200px;
	}
    .phase-title {
        padding: 0;
    }
	.phase-title::before {
		top: -40px;
	}
	.phase-title.mode-open {
    	font-size: 2rem;
	}
}

.strategy-img {
	width: 100%;
	height: 100%;
	margin-bottom: 25px;
}
</style>
